import { render, staticRenderFns } from "./addPanel.vue?vue&type=template&id=333e2b63&"
import script from "./addPanel.vue?vue&type=script&lang=js&"
export * from "./addPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "addPanel.vue"
export default component.exports